import { policyEffects } from '../../../enums';

export const EFFECTS = [
  {
    id: 1,
    label: policyEffects.ALLOW,
    value: policyEffects.ALLOW,
  },
  { id: 2, label: policyEffects.DENY, value: policyEffects.DENY },
];

export const ALL_PERMISSIONS_SHORTCUT = '<.*>';

export const SYSTEM = 'system';
export const INTERNAL = 'internal';
export const CUSTOMER = 'customer';
